import React, { useContext } from "react";
import { Outlet } from "react-router";

import Navbar from "../components/navbar";
import Sidebar from "../components/sidebar";
import { MenuContext } from "../providers/menu";

const MenuLayout = () => {
  const { scrollToTopIsVisible, scrollToTop } = useContext(MenuContext);

  return (
    <div id="wrapper">
      <Sidebar />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Navbar />
          <div className="container-fluid page-wrapper">
            <Outlet />
          </div>
        </div>
      </div>
      {scrollToTopIsVisible ? (
        <button
          className="btn btn-primary"
          onClick={scrollToTop}
          style={{ position: "fixed", right: "8px", bottom: "8px" }}
        >
          <i className="fas fa-angle-up"></i>
        </button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default MenuLayout;
